import type { LiveInfo } from "@tih/shared";
import { isBroadcastLive } from "../../lib/live-display";
import { LiveLandingPage } from "../../pages/LiveLandingPage";

type Props = {
  liveInfo: LiveInfo | null;
  /** True when homepage video / last stream should show (same as EventGrid showLiveVideo). */
  showLiveVideo: boolean;
  posterUrl?: string | null;
};

/** Replay of a past overnight — rendered after directions, not in the hero band. */
export function shouldShowComingSoonReplay({
  liveInfo,
  showLiveVideo,
  posterUrl,
}: Props): boolean {
  return Boolean(showLiveVideo && posterUrl && !isBroadcastLive(liveInfo));
}

export function ComingSoonReplay({ liveInfo, showLiveVideo, posterUrl }: Props) {
  if (!shouldShowComingSoonReplay({ liveInfo, showLiveVideo, posterUrl })) {
    return null;
  }

  return (
    <section className="coming-soon-replay-below" aria-label="Previous overnight replay">
      <div className="coming-soon-replay-below-inner">
        <div className="coming-soon-replay-below-head">
          <div className="coming-soon-map-eyebrow">
            <span className="rule" />
            <span>Last overnight</span>
            <span className="rule" />
          </div>
        </div>
        <div className="coming-soon-live-video coming-soon-live-video--below">
          <LiveLandingPage initialInfo={liveInfo} />
        </div>
      </div>
    </section>
  );
}
